import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { stableSort, getSorting } from './utils';
import ActionButtons from './actions-buttons';

const ContentTable = props => {
  const { service, data, order, orderBy, selected } = props;

  const { hasCheckbox = false, tableHeader = [] } = service;
  const key = service.getKeyTable();

  const handleClick = (event, id) => {
    const { onRowClick = null } = service;
    if (onRowClick) {
      onRowClick(props)(id);
    }
  };
  const handleSelected = id => selected.indexOf(id) !== -1;

  const getValue = (row, elem) => {
    const value = row[elem.id];
    if (elem.format) {
      return !value ? '' : elem.format(value);
    }
    if (elem.actions) {
      const actionProps = { ...props, value };
      return <ActionButtons {...actionProps} />;
    }
    return value;
  };
  return (
    <TableBody>
      {stableSort(data, getSorting(order, orderBy)).map(n => {
        const isSelected = handleSelected(n[key]);

        return (
          <TableRow
            hover
            onClick={event => handleClick(event, n[key])}
            role="checkbox"
            aria-checked={isSelected}
            tabIndex={-1}
            key={`table-row-${n[key].toString()}`}
            selected={isSelected}
          >
            {hasCheckbox ? (
              <TableCell padding="checkbox">
                <Checkbox checked={isSelected} />
              </TableCell>
            ) : (
              ''
            )}

            {tableHeader.map((elem, index) => (
              <TableCell
                align={elem.numeric ? 'right' : 'left'}
                padding={elem.disablePadding ? 'none' : 'default'}
                component="th"
                scope="row"
                style={elem.style}
                key={index.toString()}
              >
                {getValue(n, elem)}
              </TableCell>
            ))}
          </TableRow>
        );
      })}
    </TableBody>
  );
};

ContentTable.propTypes = {};

export default ContentTable;
